<script setup lang="ts">
    import LogFilter from '@/components/log/LogFilter.vue';
    import { useQuery } from '@tanstack/vue-query';
    import axios from 'axios';
    import { useLogStore } from '@/stores/log';
    import QueryKey from '@/enums/QueryKey';

    const logStore = useLogStore();

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.ACTIVITIES],
        queryFn: getActivities,
        placeholderData: {
            by: [],
            description: [],
            action: [],
            for: [],
        },
    });

    async function getActivities() {
        const { data } = await axios.get(route('v2.log.activities'), {
            params: {
                fromDate: logStore.startDate.toString(),
                toDate: logStore.endDate.toString(),
                selectedRows: logStore.selectedRows,
            },
        });
        return data;
    }
</script>

<template>
    <div class="grid grid-cols-1 items-start gap-2 sm:grid-cols-2 lg:grid-cols-4">
        <LogFilter
            v-for="filter in logStore.filters"
            :name="filter.name"
            :label="filter.label"
            :data="data[filter.name] || []"
            :loading="isFetching"
        />
    </div>
</template>
